import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import ScheduleReadyItems from './ScheduleReadyItems';
import SchedulePickupCheckModal from './SchedulePickupCheckModal';
import * as DateHelpers from './DateHelpers';
import * as _ from 'lodash';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import authService from './api-authorization/AuthorizeService';

interface GenericList {
    id: number;
    description: string;
}

interface Schedule {
    scheduleItems: ScheduleItem[];
    showItems: boolean;
    install: ScheduleItemDetails[];
    pickup: ScheduleItemDetails[];
    editNotes: EditNotes;
    noteTypes: GenericList[];
    showNotes: boolean;
    noteDetails: NoteDetails;
    showAddNote: boolean;
    siteAddressFilter: string;
    idFilter: number;
    allowAllocateToPastDate: boolean;
    pickupDateChanged: boolean;
    showSchedulePickupCheck: boolean;
    errors: any;
    loading: boolean;
    saveDisabled: boolean;
};

interface NoteDetails {
    truckAccess: string;
    parking: string;
    siteClean: string;
    powerlines: string;
    itemNotes: string;
    noteList: NoteList[]; 
}

interface NoteList {
    id: number,
    type: string,
    item: string,
    dateFormatted: string,
    notes: string,
    addedBy: string,
    systemNote: boolean
}

interface ScheduleItem {
    origItemIndex: number;  //index from pickup/install list - if set means we have scheduled and unscheduled without saving
    itemIndex: number;
    id: number;
    jobId: number;
    itemId: number;
    item: string;
    jobQuoteItemId: number;
    type: string;
    typeId: number;
    hirePeriodActual: number;
    hirePeriod: string;
    siteAddress: string;
    status: string;
    quantityTotal: number;
    quantityScheduled: number;
    scheduledDate: string;
    installationDate: string;
    onhireDate: string;
    offhireDate: string;
    pickupDate: string;
    paid: boolean;
    goAhead: boolean;
    accountTypeId: number;
    allowOnGoingHire: number;
    chargePublicHoliday: boolean;
    chargeShutdownPeriod: boolean;
    purchaseOrderNumber: string;
    showRedNotes: boolean;
    pickupScheduled: boolean;
    callout: boolean;
    extraHours: number;
    copy: boolean;
    isDirty: boolean;
}

interface ScheduleItemDetails {
    itemIndex: number;
    jobQuoteItemId: number;
    jobId: number;
    itemId: number;
    siteAddress: string;
    customer: string;
    item: string;
    status: string;
    quantityTotal: number;
    quantityScheduled: number;
    quantityType: string;
    hirePeriodActual: number;
    hirePeriod: string;
    accountTypeId: number;
    allowOnGoingHire: number;
    chargePublicHoliday: boolean;
    chargeShutdownPeriod: boolean;
    selected: boolean;
    scheduled: boolean;
    showDetail: boolean;
    extraHours: number;
    callout: boolean;
    items: ScheduleRelatedItemDetails[];
    showRedNotes: boolean;
    notes: string;
}

interface ScheduleRelatedItemDetails {
    jobQuoteItemId: number;
    jobId: number;
    itemId: number;
    item: string;
    status: string;
    quantityTotal: number;
    quantityScheduled: number;
    quantityType: string;
    hirePeriod: string;
}

interface EditNotes {
    jobId: number;
    jobQuoteItemId: number;
    noteTypeId: number;
    notes: string;
}

interface INameToValueMap {
    [key: string]: any;
}

export class ScheduleData extends React.Component<RouteComponentProps<{}>, Schedule> {
    constructor(props: any) {
        super(props);

        this.state = {
            scheduleItems: [],
            install: [],
            pickup: [],
            editNotes: {
                jobId: 0,
                jobQuoteItemId: 0,
                noteTypeId: -1,
                notes: ""
            },
            noteTypes: [],
            showNotes: false,
            showItems: true,
            showAddNote: false,
            noteDetails: {
                truckAccess: "",
                parking: "",
                siteClean: "",
                powerlines: "",
                itemNotes: "",
                noteList: []
            },
            siteAddressFilter: "",
            idFilter: 0,
            allowAllocateToPastDate: false,
            pickupDateChanged: false,
            showSchedulePickupCheck: false,
            errors: {},
            loading: true,
            saveDisabled: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let userParams: INameToValueMap = {};
        userParams["id"] = 0;
        userParams = this.props.match.params;
        let Id = userParams["id"];
        if (!Id) {
            Id = 0;
        }

        axios.get('api/User/CheckUserPermission?Permission=CreateEditSchedule&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                if (res.data == true) {
                    //get items to be scheduled
                    axios.get('api/Schedule/GetSchedulingItems?SubId=' + user.sub, {
                        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                    })
                        .then(res => {
                            var installs = res.data.installItems;
                            for (var i = 0; i < installs.length; i++) {
                                installs[i].itemIndex = i;
                            }
                            var pickups = res.data.pickupItems;
                            for (var i = 0; i < pickups.length; i++) {
                                pickups[i].itemIndex = i;
                            }

                            var tenative = res.data.tenativeItems;
                            for (var i = 0; i < tenative.length; i++) {
                                tenative[i].itemIndex = i;
                            }

                            this.setState({ idFilter: Id, install: installs, pickup: pickups, scheduleItems: tenative, noteTypes: res.data.noteTypes, allowAllocateToPastDate: res.data.allowAllocateToPastDate, loading: false })
                        })
                        .catch(error => {
                            toast.error(error.message);
                        });
                } else {
                    //redirect to 403 permission denied
                    this.props.history.push("/accessdenied")
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    onCellChange = (itemIndex: number, item: string, value: any) => {
        //update item that has changed
        var scheduledItems = this.state.scheduleItems;
        var scheduleItem = scheduledItems[itemIndex];
        let newScheduleItem: any = {};
        newScheduleItem = scheduleItem;
        newScheduleItem[item] = value;
        //set isdirty flag so we know the record has been modified
        scheduleItem.isDirty = true;
        this.setState({ scheduleItems: scheduledItems });

        if (item == "onhireDate" && DateHelpers.isValidDate(value)) {
            //need to check if overhire is available, if not, then calculate the offhire date based on hire period (actual)
            //exclude callout items
            if (scheduleItem.allowOnGoingHire == 0 && !scheduleItem.callout) {
                this.getOffhireDate(value, scheduledItems, scheduleItem);
            } else {
                this.setState({ scheduleItems: scheduledItems });
            }
        }
        else if (item === "pickupDate" && scheduleItem.typeId === 2) {
            this.setState({ pickupDateChanged: true });
        }

    }

    async getOffhireDate(onhireDate: string, scheduledItems: ScheduleItem[], scheduleItem: ScheduleItem) {
        const token = await authService.getAccessToken();

        axios.get('api/Schedule/CalculateOffhireDate?OnhireDate=' + onhireDate + '&ChargePublicHols=' + scheduleItem.chargePublicHoliday + '&ShutdownPeriodType=' + scheduleItem.chargeShutdownPeriod + '&HirePeriod=' + scheduleItem.hirePeriodActual, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            scheduleItem.offhireDate = res.data;
            this.setState({ scheduleItems: scheduledItems });
        })
        .catch(error => {
            toast.error(error.message);
        });

    }

    copyItem = (e: any, itemIndex: number) => {
        e.preventDefault();
        var scheduledItems = this.state.scheduleItems;
        var newItem = _.cloneDeep(scheduledItems[itemIndex]);
        //reset id, dates and flags on new item
        newItem.id = 0;
        newItem.itemIndex = scheduledItems.length;
        newItem.installationDate = "";
        newItem.onhireDate = "";
        newItem.offhireDate = "";
        newItem.pickupDate = "";
        newItem.paid = false;
        newItem.goAhead = false;
        newItem.quantityScheduled = 0;
        newItem.status = "Quoted";
        newItem.purchaseOrderNumber = "";
        newItem.copy = true;
        newItem.isDirty = true;

        scheduledItems.push(newItem);
        this.setState({ scheduleItems: scheduledItems });
    }

    cancelItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        this.unscheduleItem(itemIndex);
    }

    async unscheduleItem(itemIndex: number) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //get the item to be cancelled
        var scheduledItems = this.state.scheduleItems;
        var scheduleItem = scheduledItems[itemIndex];
        var scheduleId = scheduleItem.id;
        var jobQuoteItemId = scheduleItem.jobQuoteItemId;
        var typeId = scheduleItem.typeId;
        var origItemIndex = scheduleItem.origItemIndex;
        //cancel will just remove it from the schedule list and set it back to quoted status so can re-schedule
        scheduledItems.splice(itemIndex, 1);

        //update item index
        for (var i = 0; i < scheduledItems.length; i++) {
            scheduledItems[i].itemIndex = i;
        }

        //reset the status on the database and get the updated item back
        axios.get('api/Schedule/UnscheduleItem?ScheduleId=' + scheduleId + '&JobQuoteItemId=' + jobQuoteItemId + '&ItemId=' + scheduleItem.itemId + '&Item=' + scheduleItem.item + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                if (typeId == 1) {
                    //install
                    var install = this.state.install;
                    if (origItemIndex >= 0) {
                        //means the item is in the item list so need to update rather than add new
                        install[origItemIndex].selected = false;
                        install[origItemIndex].scheduled = false;
                        install[origItemIndex].showDetail = false;
                    } else {
                        install.push(res.data);
                    }
                    this.setState({ install: install, scheduleItems: scheduledItems })
                } else {
                    //pickup
                    var pickup = this.state.pickup;
                    if (origItemIndex >= 0) {
                        //means the item is in the item list so need to update rather than add new
                        pickup[origItemIndex].selected = false;
                        pickup[origItemIndex].scheduled = false;
                        pickup[origItemIndex].showDetail = false;
                    } else {
                        pickup.push(res.data);
                    }
                    this.setState({ pickup: pickup, scheduleItems: scheduledItems })
                }
                toast.success("Item has been unscheduled");
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    showItems = () => {
        this.setState({ showItems: !this.state.showItems });
    }

    updateInstalls = (data: any) => {
        this.setState({ install: data.install });
    }

    updatePickups = (data: any) => {
        this.setState({ pickup: data.pickup });
    }

    scheduleItems = (data: any) => {

        //update item index
        for (var i = 0; i < data.scheduledItems.length; i++) {
            data.scheduledItems[i].itemIndex = i;
        }
        this.setState({ scheduleItems: data.scheduledItems });
    }

    //NOTES
    handleNotesChange = (e: any) => {
        var editNotes = this.state.editNotes;
        let newNotes: any = {};
        newNotes = editNotes;
        newNotes[e.target.name] = e.target.value;

        this.setState({ editNotes: editNotes, errors: {} });
    }

    editNotes = (e: any, jobId: number, jobQuoteItemId: number) => {
        e.preventDefault();

        var editNote: EditNotes = {
            jobId: jobId,
            jobQuoteItemId: jobQuoteItemId,
            noteTypeId: -1,
            notes: ""
        }

        this.getNotes(jobId, jobQuoteItemId);

        this.setState({ editNotes: editNote, showNotes: true, errors: {} });
    }

    async getNotes(jobId: number, jobQuoteItemId: number) {
        const token = await authService.getAccessToken();

        //get list of notes from database
        axios.get('api/Job/GetScheduleNotes?jobId=' + jobId + '&jobQuoteItemId=' + jobQuoteItemId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                this.setState({ noteDetails: res.data });
            })
    }

    showAddNote = () => {
        var showNote = !this.state.showAddNote;
        this.setState({ showAddNote: showNote });
    }

    validateNotes = () => {
        let fields = this.state.editNotes;
        let errors: any = {};
        let formIsValid = true;

        if (fields.noteTypeId <= 0) {
            formIsValid = false;
            errors["noteTypeId"] = "Note Type is required";
        }

        if (!fields.notes || fields.notes.length < 5) {
            formIsValid = false;
            errors["notes"] = "Notes > 5 characters are required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    saveNotes = () => {
        if (this.validateNotes()) {
            this.saveJobNote();
        }
    }

    async saveJobNote() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var editNotes = this.state.editNotes;
        let jobNotes = {
            jobId: editNotes.jobId,
            noteTypeId: editNotes.noteTypeId,
            note: editNotes.notes,
            subId: user.sub
        };

        axios.post('api/Job/SaveJobNote', jobNotes, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Note Saved");
            this.getNotes(editNotes.jobId, editNotes.jobQuoteItemId);
        })
        .catch(error => {
            toast.error(error.message);
        });

        var resetNotes: EditNotes = {
            jobId: 0,
            jobQuoteItemId: 0,
            noteTypeId: -1,
            notes: ""
        }

        var resetNoteList: NoteDetails = {
            truckAccess: "",
            parking: "",
            siteClean: "",
            powerlines: "",
            itemNotes: "",
            noteList: []
        }

        this.setState({ editNotes: resetNotes, noteDetails: resetNoteList, errors: {} });
    }

    hideNotesModal = () => {
        var resetNotes: EditNotes = {
            jobId: 0,
            jobQuoteItemId: 0,
            noteTypeId: -1,
            notes: ""
        }

        var resetNoteList: NoteDetails = {
            truckAccess: "",
            parking: "",
            siteClean: "",
            powerlines: "",
            itemNotes: "",
            noteList: []
        }

        this.setState({ showNotes: false, showAddNote: false, editNotes: resetNotes, noteDetails: resetNoteList, errors: {} });
    }
    //END NOTES

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        //only validate items that have changed as those are the ones we are saving
        var minDate = this.state.allowAllocateToPastDate ? DateHelpers.addDaysToCurrentDate(-7) : DateHelpers.getCurrentDate();
        var minOffhireDate = DateHelpers.addDaysToCurrentDate(-30);
        let items = this.state.scheduleItems.filter(x => x.isDirty);
        var rowNumber = 0;

        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < items.length; i++) {
            rowNumber += 1;
            var newErrorString = "";
            if (items[i].typeId == 1) {
                //different validation for pickup and installs
                var validDate = true;
                if (items[i].installationDate == "") {
                    newErrorString += " Installation Date, ";
                    error = true;
                    validDate = false;
                } else if (!DateHelpers.isValidDate(items[i].installationDate)) {
                    newErrorString += " Valid Installation Date, ";
                    error = true;
                    validDate = false;
                } else if (!DateHelpers.compareDateGreater(minDate, items[i].installationDate)) {
                    newErrorString += " Valid Installation Date, ";
                    error = true;
                    validDate = false;
                }
                if (items[i].onhireDate == "") {
                    newErrorString += " Onhire Date, ";
                    error = true;
                    validDate = false;
                } else if (!DateHelpers.isValidDate(items[i].onhireDate)) {
                    newErrorString += " Valid Onhire Date, ";
                    error = true;
                    validDate = false;
                } else if (!DateHelpers.compareDateGreater(minDate, items[i].onhireDate)) {
                    newErrorString += " Valid Onhire Date, ";
                    error = true;
                    validDate = false;
                }
                //only validate offhire date and pickup date for items that don't have a pickup scheduled
                //callout items don't require a pickup
                if (!items[i].pickupScheduled && !items[i].callout) {
                    if (items[i].allowOnGoingHire == 0 && items[i].offhireDate == "") {
                        //only validate this if goahead and paid ticked otherwise they can do it later
                        var acctType = items[i].accountTypeId;
                        var goahead = items[i].goAhead;
                        var paid = items[i].paid;

                        if ((acctType == 1 && paid == true && goahead == true) || (acctType != 1 && goahead == true)) {
                            //if customer not set up for on-going hire they must enter offhire and pickup dates
                            newErrorString += " Offhire Date (Customer Rule), ";
                            error = true;
                            validDate = false;
                        }
                    }
                    if (items[i].allowOnGoingHire == 0 && items[i].offhireDate != "") {
                        //check they are valid dates
                        if (!DateHelpers.isValidDate(items[i].offhireDate)) {
                            newErrorString += " Valid Offhire Date (Customer Rule), ";
                            error = true;
                            validDate = false;
                        } else if (!DateHelpers.compareDateGreater(minOffhireDate, items[i].offhireDate)) {
                            newErrorString += " Valid Offhire Date, ";
                            error = true;
                            validDate = false;
                        }
                    }
                    if (items[i].allowOnGoingHire == 0 && items[i].pickupDate == "") {
                        //only validate this if goahead and paid ticked otherwise they can do it later
                        var acctType = items[i].accountTypeId;
                        var goahead = items[i].goAhead;
                        var paid = items[i].paid;

                        if ((acctType == 1 && paid == true && goahead == true) || (acctType != 1 && goahead == true)) {
                            //if customer not set up for on-going hire they must enter offhire and pickup dates
                            newErrorString += " Pickup Date (Customer Rule), ";
                            error = true;
                            validDate = false;
                        }
                    }
                    if (items[i].allowOnGoingHire == 0 && items[i].pickupDate != "") {
                        //check they are valid dates
                        if (!DateHelpers.isValidDate(items[i].pickupDate)) {
                            newErrorString += " Valid Pickup Date (Customer Rule), ";
                            error = true;
                            validDate = false;
                        } else if (!DateHelpers.compareDateGreater(minDate, items[i].pickupDate)) {
                            newErrorString += " Valid Pickup Date, ";
                            error = true;
                            validDate = false;
                        }
                    }
                }

                if (items[i].pickupDate != "" && items[i].offhireDate == "") {
                    newErrorString += " Offhire Date, ";
                    error = true;
                    validDate = false;
                }
                if (items[i].pickupDate != "" && items[i].offhireDate != "") {
                    //check they are valid dates
                    if (!DateHelpers.isValidDate(items[i].offhireDate)) {
                        newErrorString += " Valid Offhire Date, ";
                        error = true;
                        validDate = false;
                    } else if (!DateHelpers.compareDateGreater(minOffhireDate, items[i].offhireDate)) {
                        newErrorString += " Valid Offhire Date, ";
                        error = true;
                        validDate = false;
                    }
                    if (!DateHelpers.isValidDate(items[i].pickupDate)) {
                        newErrorString += " Valid Pickup Date, ";
                        error = true;
                        validDate = false;
                    } else if (!DateHelpers.compareDateGreater(minDate, items[i].pickupDate)) {
                        newErrorString += " Valid Pickup Date, ";
                        error = true;
                        validDate = false;
                    }
                }
                if (validDate) {
                    if (items[i].offhireDate != "") {
                        //check to make sure install date is before or equal to offhire date
                        if (!DateHelpers.compareDate(items[i].installationDate, items[i].offhireDate)) {
                            newErrorString += " Install Date must be <= Offhire Date, ";
                            error = true;
                        }

                        if (items[i].pickupDate != "") {
                            //check to make sure offhire date is before or equal to pickup date
                            if (!DateHelpers.compareDate(items[i].offhireDate, items[i].pickupDate)) {
                                newErrorString += " Offhire Date must be <= Pickup Date, ";
                                error = true;
                            }
                        }
                    }
                }
                if (items[i].accountTypeId == 3 && !items[i].purchaseOrderNumber) {
                    newErrorString += " Purchase Order Number, ";
                    error = true;
                }
            } else {
                var validDate = true;
                if (items[i].offhireDate == "") {
                    newErrorString += " Offhire Date, ";
                    error = true;
                    validDate = false;
                } else if (!DateHelpers.isValidDate(items[i].offhireDate)) {
                    newErrorString += " Valid Offhire Date, ";
                    error = true;
                    validDate = false;
                } else if (!DateHelpers.compareDateGreater(minOffhireDate, items[i].offhireDate)) {
                    newErrorString += " Valid Offhire Date, ";
                    error = true;
                    validDate = false;
                }
                if (items[i].pickupDate == "") {
                    newErrorString += " Pickup Date, ";
                    error = true;
                    validDate = false;
                } else if (!DateHelpers.isValidDate(items[i].pickupDate)) {
                    newErrorString += " Valid Pickup Date, ";
                    error = true;
                    validDate = false;
                } else if (!DateHelpers.compareDateGreater(minDate, items[i].pickupDate)) {
                    newErrorString += " Valid Pickup Date, ";
                    error = true;
                    validDate = false;
                }
                if (validDate) {
                    //check to make sure offhire date is before or equal to pickup date
                    if (!DateHelpers.compareDate(items[i].offhireDate, items[i].pickupDate)) {
                        newErrorString += " Offhire Date must be <= Pickup Date, ";
                        error = true;
                    }
                }
            }
               
            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }
            
        }
        if (error) {
            formIsValid = false;
            errors["scheduleItems"] = errorString;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    submit = (e: any) => {
        e.preventDefault();

        if (this.state.saveDisabled) {
            return;
        }

        this.setState({ saveDisabled: true });
        
        if (this.validate()) {
            //only save items that have changed
            var schedule = this.state.scheduleItems.filter(x => x.isDirty);

            if (schedule.length > 0) {
                if (this.state.pickupDateChanged) {
                    //show popup to check dates
                    this.setState({ showSchedulePickupCheck: true });
                } else {
                    this.save();
                }
            } else {
                this.setState({ saveDisabled: false });
                toast.info("No items have been changed!");
            }
        } else {
            this.setState({ saveDisabled: false });
            //alert("Form has errors.")
        }
    }

    hidePickupCheck = () => {
        this.setState({ showSchedulePickupCheck: false, saveDisabled: false });
    }

    save = () => {
        this.saveSchedule();
    }

    async saveSchedule() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        var schedule = this.state.scheduleItems.filter(x => x.isDirty);

        var saveSchedule = {
            scheduleItems: schedule,
            subId: user.sub
        };

        //save
        axios.post('api/Schedule/SaveSchedule', saveSchedule, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Schedule Saved");

            //get items to be scheduled
            axios.get('api/Schedule/GetTenativeItems', {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                var tenative = res.data;
                for (var i = 0; i < tenative.length; i++) {
                    tenative[i].itemIndex = i;
                }
                this.setState({ showSchedulePickupCheck: false, scheduleItems: tenative, pickupDateChanged: false, loading: false, saveDisabled: false })
            })
            .catch(error => {
                this.setState({ saveDisabled: false });
                toast.error(error.message);
            });
        })
        .catch(error => {
            this.setState({ saveDisabled: false });
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var scheduleItems = this.state.scheduleItems;
        var maxDate = DateHelpers.addYeartoCurrentDate(2);
        let filteredNoteTypes = this.state.noteTypes.filter(type =>
            type.id > 0
        )
        let powerlineslabel = "Powerlines < 4.6m:";

        if (this.state.siteAddressFilter) {
            scheduleItems = scheduleItems.filter(sch =>
                sch.siteAddress.toLowerCase().indexOf(this.state.siteAddressFilter.toLowerCase()) > -1
            );
        }

        if (this.state.idFilter != 0) {
            scheduleItems = scheduleItems.filter(sch =>
                sch.id == this.state.idFilter
            );
        }

        var scheduleChanged = this.state.scheduleItems.filter(x => x.isDirty && x.typeId === 2);

        let contents = <ScheduleReadyItems scheduleItems={this.state.scheduleItems} install={this.state.install} pickup={this.state.pickup} isModal={false} updateInstalls={this.updateInstalls} updatePickups={this.updatePickups} save={this.scheduleItems} />
        let pickupCheck = <SchedulePickupCheckModal schedule={scheduleChanged} showModal={this.state.showSchedulePickupCheck} hideModal={this.hidePickupCheck} cancel={this.hidePickupCheck} save={this.save} />

        return (
            <form onSubmit={this.submit}>
                <div>
                    <button className="defaultbutton marginBottom10" onClick={this.showItems} type="button">{this.state.showItems ? "Hide Items" : "Show Items"}</button>
                </div>
                <div className={this.state.showItems ? "" : "hidden"}>
                    {contents}
                </div>
                <div>
                    <hr></hr>
                </div>
                {pickupCheck}
                <div className="static-modal">
                    <Modal size="lg" show={this.state.showNotes} onHide={this.hideNotesModal}>
                        <Modal.Header className="modal__header--colour">
                            <Modal.Title>Notes</Modal.Title>
                            <button type="button" className="close" onClick={this.hideNotesModal}>&times;</button>
                        </Modal.Header>
                        <Modal.Body>
                            <div className={this.state.showAddNote ? "hidden" : ""}>
                                <button className="defaultbutton defaultbutton__small form-margin" onClick={this.showAddNote} type="button">Add Note</button>
                            </div>
                            <div className={this.state.showAddNote ? "" : "hidden"}>
                                <label className="input-group" htmlFor="noteType">
                                    <span className="label">Type </span>
                                    <select className="select" id="noteType" name="noteTypeId" value={this.state.editNotes.noteTypeId} onChange={(e) => this.handleNotesChange(e)}>
                                        <option hidden defaultValue="-1"></option>
                                        {filteredNoteTypes.map(type =>
                                            <option key={type.id} value={type.id}>{type.description}</option>
                                        )};
                                    </select>
                                </label>
                                <span className="label errors">{this.state.errors["noteTypeId"]}</span>
                                <label className="input-group" htmlFor="notes">
                                    <span className="label">Notes</span>
                                    <textarea className="input job__noteSize" id="notes" name="notes" value={this.state.editNotes.notes} onChange={(e) => this.handleNotesChange(e)}></textarea>
                                </label>
                                <span className="label errors">{this.state.errors["notes"]}</span>
                                <button className="marginLeftLabel popup-button--yes" onClick={this.saveNotes}>Save</button>
                                <div>
                                    <hr></hr>
                                </div>
                            </div>
                            <label className="input-group allocatepopup__nomargin">
                                <span className="label"></span>
                                <span className={this.state.noteDetails.truckAccess == 'No' ? "label label__red" : "label"}>Truck Access: {this.state.noteDetails.truckAccess}</span>
                                <span className={this.state.noteDetails.parking == 'No' ? "label label__red" : "label"}>Parking Avail: {this.state.noteDetails.parking}</span>
                            </label>
                            <label className="input-group allocatepopup__nomargin">
                                <span className="label"></span>
                                <span className={this.state.noteDetails.siteClean == 'No' ? "label label__red" : "label"}>Site Clean: {this.state.noteDetails.siteClean}</span>
                                <span className={this.state.noteDetails.powerlines == 'Yes' ? "label label__red" : "label"}>{powerlineslabel} {this.state.noteDetails.powerlines}</span>
                            </label>
                            <div>
                                <hr></hr>
                            </div>
                            <div>
                                <span>Item Notes: {this.state.noteDetails.itemNotes}</span>
                            </div>
                            <div>
                                <hr></hr>
                            </div>
                            <div className="schedule__noteGridSize overflowAuto">
                                <table className="table tableColours">
                                    <thead>
                                        <tr>
                                            <th>Date/Time</th>
                                            <th>Type</th>
                                            <th>Item</th>
                                            <th>Notes</th>
                                            <th>Added By</th>
                                        </tr>
                                    </thead>
                                    {this.state.noteDetails.noteList.map((note, index) =>
                                        <tbody key={note.id}>
                                            <tr>
                                                <td>{note.dateFormatted}</td>
                                                <td>{note.type}</td>
                                                <td>{note.item}</td>
                                                <td>{note.notes}</td>
                                                <td>{note.addedBy}</td>
                                            </tr>
                                        </tbody>
                                    )}
                                </table>
                            </div>

                        </Modal.Body>
                    </Modal>
                </div>
                <div>
                    <div className="input-group-parent">
                        <label className="input-group" htmlFor="siteAddressFilter">
                            <span className="label">Site Address</span>
                            <input className="input" type="text" id="siteAddressFilter" name="siteAddressFilter" value={this.state.siteAddressFilter} onChange={(e) => this.handleChange(e)}></input>
                        </label>
                    </div>
                    <div className="input-group-parent">
                        <div className="colAlignRight">
                            <button className="defaultbutton" type="submit" disabled={this.state.saveDisabled}>Save</button>
                        </div>
                    </div>
                </div>
                <div className="table__margin overflowAuto">
                    <table className="table table__large tableColours">
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th></th>
                                <th>Item</th>
                                <th>Type</th>
                                <th>Hire Period</th>
                                <th>Address</th>
                                <th>Status</th>
                                <th className="hidden">Scheduled Date</th>
                                <th>Installation Date</th>
                                <th>Onhire Date</th>
                                <th>Offhire Date</th>
                                <th>Pickup Date</th>
                                <th>P/O</th>
                                <th>Paid</th>
                                <th>Go Ahead</th>
                                <th>Notes</th>
                                <th>Copy</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {scheduleItems.map((item, index) =>
                                <tr key={index}>
                                    <td className="hidden">{item.id}</td>
                                    <td className="table__text--align">{index + 1}</td>
                                    <td className="table__text--align"> {item.item}</td>
                                    <td className="table__text--align">{item.type}</td>
                                    <td className="table__text--align">{item.hirePeriod}</td>
                                    <td className="table__text--align">
                                        <Link to={'/job/' + item.jobId} target="_blank">
                                            <div className="tooltipitem tooltipitem__right">{item.siteAddress ? item.siteAddress.substring(0, 20) + "... " : ""}
                                                <span className="tooltipitemtext tooltipitemtext__right">{item.siteAddress}</span>
                                            </div>
                                        </Link>
                                    </td>
                                    <td className="table__text--align">{item.status}</td>
                                    <td className="hidden">{item.scheduledDate}</td>
                                    <td><input type={item.type == "Install" ? "date" : "hidden"} max={maxDate} className={item.type == "Install" ? "form-control" : "hidden"} value={item.installationDate} onChange={(e) => this.onCellChange(item.itemIndex, "installationDate", e.target.value)} disabled={item.status == "Cancelled" ? true : false} /></td>
                                    <td><input type="date" max={maxDate} className={item.type == "Install" ? "form-control" : "hidden"} value={item.onhireDate} onChange={(e) => this.onCellChange(item.itemIndex, "onhireDate", e.target.value)} disabled={item.status == "Cancelled" ? true : false} /></td>
                                    <td><input type="date" max={maxDate} className={item.pickupScheduled || item.callout ? "hidden" : "form-control"} value={item.offhireDate} onChange={(e) => this.onCellChange(item.itemIndex, "offhireDate", e.target.value)} disabled={item.status == "Cancelled" ? true : false} /></td>
                                    <td><input type="date" max={maxDate} className={item.pickupScheduled || item.callout ? "hidden" : "form-control"} value={item.pickupDate} onChange={(e) => this.onCellChange(item.itemIndex, "pickupDate", e.target.value)} disabled={item.status == "Cancelled" ? true : false} /></td>
                                    <td><input type="text" className={item.type == "Install" ? "form-control schedule__posize" : "hidden"} value={item.purchaseOrderNumber} onChange={(e) => this.onCellChange(item.itemIndex, "purchaseOrderNumber", e.target.value)} disabled={item.status == "Cancelled" ? true : false}></input></td>
                                    <td><input type='checkbox' className={(item.type == "Install" && item.accountTypeId == 1) ? "input" : "hidden"} checked={item.paid} onChange={(e) => this.onCellChange(item.itemIndex, "paid", e.target.checked)} disabled={item.status == "Cancelled" ? true : false} /></td>
                                    <td><input type='checkbox' className='input' checked={item.goAhead} onChange={(e) => this.onCellChange(item.itemIndex, "goAhead", e.target.checked)} disabled={item.status == "Cancelled" ? true : false} /></td>
                                    <td>
                                        <a data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => this.editNotes(e, item.jobId, item.jobQuoteItemId)}>
                                            <span className={item.showRedNotes ? "fas fa-pencil-alt edit--icon alignIconCenter makeitred" : "fas fa-pencil-alt edit--icon alignIconCenter"}></span>
                                        </a>
                                    </td>
                                    <td>
                                        <div className="hidden">
                                            <a href="#" onClick={(e) => this.copyItem(e, item.itemIndex)}>
                                                <span className="fas fa-copy copy--icon"></span>
                                            </a>
                                        </div>
                                    </td>
                                    <td>
                                        {item.status != "Cancelled" ?
                                            <div className="delete--tablecell">
                                                <a className="makeitred" href="#" onClick={(e) => this.cancelItem(e, item.itemIndex)}>
                                                    <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                </a>
                                            </div> : ""
                                        }
                                    </td>
                                </tr>

                            )}
                        </tbody>
                    </table>
                    {this.state.errors["scheduleItems"] ?
                        (this.state.errors["scheduleItems"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
                <div className = "colAlignRight">
                    <button className="defaultbutton-next marginBottom10" type="submit" disabled={this.state.saveDisabled}>Save</button>
                </div>
            </form>
        );

    }

};
